export var PAGE_TITLE_ID = 'page-title';
